module.exports = __webpack_public_path__ + "static/media/GreyHound.4fb6dd8d.svg";